export default "__VITE_ASSET__BsCdPWhV__"